import React, { useEffect, useState } from 'react';
import { Box, SelectInput2 } from '@qwealth/qcore';
import { QNote } from '@qwealth/qdata';
import InfoTag from 'components/common/SectionHeader/InfoTag';

interface QNoteVersionSelectorProps {
  qnotes: QNote[];
  onChange: (note: QNote) => void;
}

const QNoteVersionSelector: React.FC<QNoteVersionSelectorProps> = ({ qnotes, onChange }) => {
  const [versionIdToTitleMap, setVersionIdToTitleMap] = useState<Record<number, string>>({});

  useEffect(() => {
    const notesMap: { [key: string]: string } = {};
    qnotes.forEach(note => {
      notesMap[note?.uuid as string] = note.title;
    });
    setVersionIdToTitleMap(notesMap);
  }, []);

  const getQNote = (uuid: string | undefined) => {
    return qnotes.find(note => note.uuid === uuid);
  };

  return (
    <Box>
      <Box fontWeight="bold" marginBottom="small">
        Version
      </Box>
      <Box display="flex" flexDirection="row" alignItems="baseline">
        <SelectInput2
          height="41px"
          width="275px"
          toLabel={option => versionIdToTitleMap[option]}
          onChange={option => {
            const note = getQNote(option as string | undefined);
            if (note) {
              onChange(note);
            }
          }}
          data={qnotes.map(note => note?.uuid as string)}
        />
        <Box marginLeft="default">
          <InfoTag tagTitle="Wealthbox" />
        </Box>
      </Box>
    </Box>
  );
};

export default QNoteVersionSelector;
